(function(){
  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn);
    else fn();
  }

  ready(function(){
    var section=document.querySelector('#shopify-section-home .news');
    if(!section) return;

    var form=section.querySelector('form');
    if(!form || form.dataset.anNewsletterReady==='1') return;
    form.dataset.anNewsletterReady='1';

    var input=form.querySelector('input[type="email"][name="contact[email]"]');
    var button=form.querySelector('button[type="submit"]');
    if(!input || !button) return;

    input.setAttribute('autocomplete','email');
    input.setAttribute('inputmode','email');

    var status=document.createElement('div');
    status.className='an-newsletter-status';
    status.setAttribute('role','status');
    status.setAttribute('aria-live','polite');
    form.appendChild(status);

    var existingSuccess=[].slice.call(form.querySelectorAll('p')).find(function(p){
      return /subscribed\. welcome to after note\./i.test(p.textContent||'');
    });

    function showSuccess(){
      if(existingSuccess) existingSuccess.remove();
      input.value='';
      input.disabled=true;
      button.disabled=true;
      button.removeAttribute('aria-busy');
      button.textContent='Subscribed';
      status.className='an-newsletter-status is-success';
      status.innerHTML='';
      var successStrong=document.createElement('strong');
      successStrong.textContent=(window.AN_THEME&&window.AN_THEME.newsletterSuccess)||'You’re on the list.';
      status.appendChild(successStrong);
    }

    function showError(message){
      button.disabled=false;
      button.removeAttribute('aria-busy');
      button.textContent='Subscribe';
      status.className='an-newsletter-status is-error';
      status.textContent=message||((window.AN_THEME&&window.AN_THEME.newsletterError)||'We could not subscribe you right now. Please check the email and try again.');
    }

    if(existingSuccess){
      showSuccess();
      return;
    }

    form.addEventListener('submit',function(event){
      event.preventDefault();

      if(!input.checkValidity()){
        input.reportValidity();
        return;
      }

      status.className='an-newsletter-status';
      status.textContent='';
      button.disabled=true;
      button.setAttribute('aria-busy','true');
      button.textContent='Subscribing…';

      fetch(form.action||window.location.href,{
        method:(form.method||'post').toUpperCase(),
        body:new FormData(form),
        credentials:'same-origin',
        headers:{'Accept':'text/html','X-Requested-With':'XMLHttpRequest'}
      }).then(function(response){
        return response.text().then(function(html){
          return {ok:response.ok,url:response.url||'',html:html||''};
        });
      }).then(function(result){
        var combined=(result.url+' '+result.html).toLowerCase();
        var success=result.ok && (
          combined.indexOf('customer_posted=true')>-1 ||
          combined.indexOf('subscribed. welcome to after note.')>-1 ||
          combined.indexOf('already subscribed')>-1 ||
          combined.indexOf('has already been taken')>-1
        );

        if(success) showSuccess();
        else showError();
      }).catch(function(){
        showError();
      });
    });
  });
})();
